// levels.js
// POWER_UPS_ENABLED and POWER_UP_AUDIO control power-up behavior
// Future power-ups can be added by extending the POWER_UPS config in constants.js
// TIME_LIMIT: number of seconds, null for infinite time
// MAX_MOVES: number of moves allowed, null for infinite moves (like bejeweled)
// BARRELS_ENABLED: boolean, enables EtherRock tiles that get damaged by adjacent explosions
const LEVELS = {
    LEVEL_1: {
      ID: "basic",
      VERSION: "1.1",
      BOARD_SIZE: 8, // 8x8 grid
      LEVEL_NAME: "Mfers Jus Getting Started",
      BG_AUDIOS: ["/audio/mfersbeheaded/tvari-tokyo-cafe-159065.mp3"],
      BG_IMAGE: "/images/mfersbeheaded/declarationofcc0.webp",
      BASIC_SOUND: "/audio/mfersbeheaded/cash-register-purchase-87313.mp3",
      TIME_LIMIT: 120,
      MAX_MOVES: null, // infinite moves for backwards compatibility
      BARRELS_ENABLED: false, // backwards compatibility
      POWER_UPS_ENABLED: true,
      POWER_UP_AUDIO: "/audio/mfersbeheaded/voice/sword.mp3",
      IMAGE_MAP: {
            1: '/images/mfersbeheaded/heads/10010.png',  // nngmi zombie
            2: '/images/mfersbeheaded/heads/1704.png',  // nngmi hoodie
            3: '/images/mfersbeheaded/heads/7419.png',  // melted
            4: '/images/mfersbeheaded/heads/6850.png',  // lobesy
            5: '/images/mfersbeheaded/heads/357.png',  // cowboy
            6: '/images/mfersbeheaded/heads/1078.png',  // monocrhome cap
            1001: '/images/mfersbeheaded/heads/5009.png',
            1002: '/images/mfersbeheaded/heads/7041.png',
            1003: '/images/mfersbeheaded/heads//7423.png', // bandana
            1004: '/images/mfersbeheaded/heads/1768.png',
            1005: '/images/mfersbeheaded/heads/1538.png',
            1006: '/images/mfersbeheaded/heads/6598.png',
      },
      ADV_SOUND_CLIPS: [
        '/audio/mfersbeheaded/voice/paco.mp3',
        '/audio/mfersbeheaded/voice/metab.mp3',
        '/audio/mfersbeheaded/voice/spawn.mp3',
        '/audio/mfersbeheaded/voice/discipline.mp3',
      ],
      CREDITS: [
        { key: "Music", value: "Tokyo Cafe by Tavari" },
        { key: "Art", value: "Declaration of CC0 by cryptoW1p0, mfers by sartoshi" },
        { key: "Sound", value: "Metabanas, Discipline, Netspawn, Paco, Shaya" },
      ]
    },
    LEVEL_2: {
      ID: "house_songs",
      VERSION: "1.0",
      BOARD_SIZE: 8, // 8x8 grid
      LEVEL_NAME: "House Songs",
      BG_AUDIOS: ["/audio/mfersbeheaded/northernrains.mp3", "/audio/mfersbeheaded/mysweetpine.mp3", "/audio/mfersbeheaded/coloradotea.mp3"],
      END_AUDIOS: [],
      BG_IMAGE: "/images/mfersbeheaded/housesongs.png",
      BASIC_SOUND: "/audio/mfersbeheaded/cash-register-purchase-87313.mp3",
      TIME_LIMIT: 120,
      MAX_MOVES: null, // infinite moves for backwards compatibility
      BARRELS_ENABLED: false, // backwards compatibility
      POWER_UPS_ENABLED: true,
      POWER_UP_AUDIO: "/audio/mfersbeheaded/voice/sword.mp3",
      IMAGE_MAP: {
        1: '/images/mfersbeheaded/heads/3084.png',  
        2: '/images/mfersbeheaded/heads/4363.png',  // wooly pine
        3: '/images/mfersbeheaded/heads/9184.png',  // pine degen
        4: '/images/mfersbeheaded/heads/2265.png',  // messy purp
        5: '/images/mfersbeheaded/heads/6087.png',  // bandit
        6: '/images/mfersbeheaded/heads/1097.png',  // wooly pine
        1001: '/images/mfersbeheaded/heads/3084-zombie.png',
        1002: '/images/mfersbeheaded/heads/1840.png',
        1003: '/images/mfersbeheaded/heads//9282.png', // bandana
        1004: '/images/mfersbeheaded/heads/2646.png',
        1005: '/images/mfersbeheaded/heads/3515.png',
        1006: '/images/mfersbeheaded/heads/367.png', // wooly zombie
      },
      ADV_SOUND_CLIPS: [
        '/audio/mfersbeheaded/voice/paco.mp3',
        '/audio/mfersbeheaded/voice/metab.mp3',
        '/audio/mfersbeheaded/voice/spawn.mp3',
        '/audio/mfersbeheaded/voice/discipline.mp3',
      ],
      CREDITS: [
        { key: "Music", value: "House Songs by pinedegen" },
        { key: "Artwork", value: "House Songs by Animated Mfers, mfers by Sartoshi" },
        { key: "Sound", value: "Metabanas, Discipline, Netspawn, Paco" },
      ]
    },
      LEVEL_4: {
        ID: "kids_friendly",
        BOARD_SIZE: 8,
        LEVEL_NAME: "Lil Mfers Playground",
        VERSION: "1.0",
        BG_AUDIOS: ["/audio/mfersbeheaded/tvari-tokyo-cafe-159065.mp3"],
        BG_IMAGE: "/images/mfersbeheaded/mfa.png",
        BASIC_SOUND: "/audio/mfersbeheaded/cash-register-purchase-87313.mp3",
        TIME_LIMIT: 300,
        MAX_MOVES: null, // infinite moves for backwards compatibility
        BARRELS_ENABLED: false, // backwards compatibility
        POWER_UPS_ENABLED: true,
        POWER_UP_AUDIO: "/audio/mfersbeheaded/voice/sword.mp3",
        IMAGE_MAP: {
              1: '/images/mfersbeheaded/heads/9058.png',
              2: '/images/mfersbeheaded/heads/9077.png',
              3: '/images/mfersbeheaded/heads/7419.png',
              4: '/images/mfersbeheaded/heads/6406.png',
              5: '/images/mfersbeheaded/heads/9106.png',
              6: '/images/mfersbeheaded/heads/869.png',
              1001: '/images/mfersbeheaded/heads/1090.png',
              1002: '/images/mfersbeheaded/heads/7041.png',
              1003: '/images/mfersbeheaded/heads//7423.png',
              1004: '/images/mfersbeheaded/heads/3926.png',
              1005: '/images/mfersbeheaded/heads/9651.png',
              1006: '/images/mfersbeheaded/heads/3.png',
        },
        ADV_SOUND_CLIPS: [
            "/audio/mfersbeheaded/cash-register-purchase-87313.mp3",
        ],
      },
      LEVEL_5: {
        ID: "nakamigo_crush",
        BOARD_SIZE: 8,
        LEVEL_NAME: "Pixel Crush",
        VERSION: "1.0",
        BG_AUDIOS: ["/audio/mfersbeheaded/tvari-lost-inside.mp3"],
        END_AUDIOS: [],
        BASIC_SOUND: "/audio/mfersbeheaded/correct.mp3",
        TIME_LIMIT: 120,
        MAX_MOVES: null, // infinite moves for backwards compatibility
        BARRELS_ENABLED: false, // backwards compatibility
        POWER_UPS_ENABLED: true,
        POWER_UP_AUDIO: "/audio/mfersbeheaded/voice/sword.mp3",
        IMAGE_MAP: {
              1: '/images/mfersbeheaded/naka/naka6219-nobg.png',
              2: '/images/mfersbeheaded/naka/naka14748-nobg.png',
              3: '/images/mfersbeheaded/naka/naka1877-nobg.png',
              4: '/images/mfersbeheaded/naka/naka1514-nobg.png',
              5: '/images/mfersbeheaded/naka/naka11953-nobg.png',
              6: '/images/mfersbeheaded/naka/naka16327-nobg.png',  
              1001: '/images/mfersbeheaded/naka/naka6219-nobg.png',
              1002: '/images/mfersbeheaded/naka/naka14748-nobg.png',
              1003: '/images/mfersbeheaded/naka/naka1877-nobg.png', 
              1004: '/images/mfersbeheaded/naka/naka1514-nobg.png',
              1005: '/images/mfersbeheaded/naka/naka11953-nobg.png',
              1006: '/images/mfersbeheaded/naka/naka16327-nobg.png',
        },
        ADV_SOUND_CLIPS: [
             "/audio/mfersbeheaded/voice/shaya-nakamigos.mp3", "/audio/mfersbeheaded/voice/success.mp3","/audio/mfersbeheaded/voice/shaya-yowassupmigo.mp3", "/audio/mfersbeheaded/decide.mp3"
        ],
        CREDITS: [
          { key: "Music", value: "Lost Inside by Tavari" },
          { key: "Art", value: "Specific nakas used with permission by Shatt_Eth, Faded Alpha + Soldman Gachs" },
          { key: "Sound", value: "Shaya, Quicksounds.com" },
        ]
      },
      LEVEL_7: {
        ID: "tiny_dino",
        VERSION: "1.0",
        BOARD_SIZE: 8, // 8x8 grid
        LEVEL_NAME: "Let's F'ing Rawr",
        BG_AUDIOS: ["/audio/mfersbeheaded/8BIT_NES-style_byNeuroPop.mp3"],
        END_AUDIOS: [],
        BASIC_SOUND: "/audio/mfersbeheaded/cartoon-jump.mp3",
        TIME_LIMIT: 120,
        MAX_MOVES: null, // infinite moves for backwards compatibility
        BARRELS_ENABLED: false, // backwards compatibility
        POWER_UPS_ENABLED: true,
        BG_IMAGE: "/images/mfersbeheaded/tinydiners.jpeg",
        POWER_UP_AUDIO: "/audio/mfersbeheaded/dragon-roar.mp3",
        IMAGE_MAP: {
              1: '/images/mfersbeheaded/tinydinos/transparent/10001.png',
              2: '/images/mfersbeheaded/tinydinos/transparent/skater.png',
              3: '/images/mfersbeheaded/tinydinos/transparent/headphones.png',
              4: '/images/mfersbeheaded/tinydinos/transparent/4684.png',
              5: '/images/mfersbeheaded/tinydinos/transparent/rainbow.png',
              6: '/images/mfersbeheaded/tinydinos/transparent/mfer.png',
              1001: '/images/mfersbeheaded/tinydinos/transparent/10001.png',
              1002: '/images/mfersbeheaded/tinydinos/transparent/skater.png',
              1003: '/images/mfersbeheaded/tinydinos/transparent/headphones.png',
              1004: '/images/mfersbeheaded/tinydinos/transparent/4684.png',
              1005: '/images/mfersbeheaded/tinydinos/transparent/rainbow.png',
              1006: '/images/mfersbeheaded/tinydinos/transparent/mfer.png',
        },
        ADV_SOUND_CLIPS: [],
        CREDITS: [
          { key: "Music", value: "#rawrcade by NeuroPopNFT" },
          { key: "Art", value: "Tiny Diners by JoanZ" },
        ]
      },
  };
  
  export default LEVELS;
  